import { useQuery } from '@tanstack/react-query';

import GradeStatsService from '@/services/grade-stats/grade-stats.service';

type DateRange = { fromMonth: string; toMonth: string };

export const useGradeStatsOverview = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'overview', params],
    queryFn: () => GradeStatsService.getOverview(params),
  });
};

export const useLessonGradesByClass = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'lesson_grades_by_class', params],
    queryFn: () => GradeStatsService.getLessonGradesByClass(params),
  });
};

export const useLessonGradesByMonth = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'lesson_grades_by_month', params],
    queryFn: () => GradeStatsService.getLessonGradesByMonth(params),
  });
};

export const usePeriodGradesByClass = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'period_grades_by_class', params],
    queryFn: () => GradeStatsService.getPeriodGradesByClass(params),
  });
};

export const useLessonGradesByCategory = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'lesson_grades_by_category', params],
    queryFn: () => GradeStatsService.getLessonGradesByCategory(params),
  });
};

export const usePeriodGradesByGradingPeriod = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'period_grades_by_grading_period', params],
    queryFn: () => GradeStatsService.getPeriodGradesByGradingPeriod(params),
  });
};

export const usePeriodGradesByCategory = (params: DateRange) => {
  return useQuery({
    queryKey: ['grade_stats', 'period_grades_by_category', params],
    queryFn: () => GradeStatsService.getPeriodGradesByCategory(params),
  });
};
